// src/constants.js
export const CATEGORIES = [
  { id: "all",      label: "הכל",           icon: "✦"    },
  { id: "starter",  label: "פתיח",           icon: "I"    },
  { id: "main",     label: "עיקרי",          icon: "II"   },
  { id: "pasta",    label: "פסטה / ריזוטו",  icon: "III"  },
  { id: "fish",     label: "דגים ופירות ים", icon: "IV"   },
  { id: "thai",     label: "תאילנדי",        icon: "V"    },
  { id: "tunisian", label: "מטבח טוניסאי",   icon: "VI"   },
  { id: "dessert",  label: "קינוח",          icon: "VII"  },
  { id: "sauce",    label: "רטבים",          icon: "VIII" },
  { id: "bread",    label: "לחם / בצקים",    icon: "IX"   },
  { id: "cocktail", label: "שתייה",          icon: "X"    },
];

export const DIFFICULTIES = ["קל", "בינוני", "מתקדם", "שף"];

export function getCat(id) {
  return CATEGORIES.find(c => c.id === id) || CATEGORIES[0];
}

export function formatDate(ts) {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("he-IL", { day: "numeric", month: "long", year: "numeric" });
}

export function copyLink(id) {
  const url = `${window.location.origin}/recipe/${id}`;
  navigator.clipboard.writeText(url).catch(() => {
    const el = document.createElement("textarea");
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  });
  return url;
}
